import React, { useEffect } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { setPageOptions } from 'reducers/layout';
import { setBreadcrumbs } from 'reducers/breadcrumbs';
// components
import { FormattedMessage } from 'react-intl';
// utils
import { isUserHasAnyRole, userRoleKeys } from 'utils/rolesHelper';

const GroupsMenuContainer = ({
  children,
  setBreadcrumbs,
  setPageOptions,
  user,
}) => {
  useEffect(() => {
    const isAdmin = !!user?.roles_map?.admin;
    const isVetOrManager = isUserHasAnyRole(user, [userRoleKeys.manager, userRoleKeys.vet]);
    const isSourcesOnly = !isAdmin && isVetOrManager;

    setBreadcrumbs();
    setPageOptions({
      links: isSourcesOnly
        ? [{ link: '/sources', label: <FormattedMessage id="general.sources" /> }]
        : [
          { link: '/groups', label: <FormattedMessage id="general.pageTitle.groups" /> },
          { link: '/sources', label: <FormattedMessage id="general.sources" /> },
          { link: '/destinations', label: <FormattedMessage id="general.destinations" /> },
        ],
    });
    return () => {
      setPageOptions({ links: null });
    };
  }, []);
  return children;
};

GroupsMenuContainer.propTypes = {
  children: T.object.isRequired,
  setPageOptions: T.func.isRequired,
  setBreadcrumbs: T.func.isRequired,
  user: T.object,
};

export default connect((state) => ({ user: state.auth.user }), { setPageOptions, setBreadcrumbs })(GroupsMenuContainer);
